import { AddCircle, Delete, Edit, InfoRounded } from "@mui/icons-material";
import {
  TableRow,
  TableCell,
  Typography,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import { ShipmentPrice } from "../../types";
import { useModal } from "@refinedev/core";
import { PriceDeleteDialog } from "./PriceDeleteDialog";
import { useTranslation } from "../../../../../hooks/useTranslation";

type ReadonlyPriceRowProps = {
  price: ShipmentPrice;
  onEditStart: () => void;
  backgroundColor?: string;
  deletable?: boolean;
};

export const ReadonlyPriceRow = (props: ReadonlyPriceRowProps) => {
  const { price, onEditStart, backgroundColor, deletable } = props;
  const { close, show, visible } = useModal();
  const { translate } = useTranslation("pages.shipmentPrices.details");

  return (
    <TableRow
      sx={{
        backgroundColor: backgroundColor,
      }}
    >
      <TableCell align="center">
        <Typography>{price.desi}</Typography>
      </TableCell>
      <TableCell align="center">
        {price.price === 0 ? (
          <Tooltip title={translate("noPriceTooltip")}>
            <InfoRounded color="error" />
          </Tooltip>
        ) : (
          <Typography>{price.price}</Typography>
        )}
      </TableCell>
      <TableCell align="center">
        <Box display="flex" justifyContent="center">
          <IconButton onClick={onEditStart} color="primary" size="small">
            {deletable ? <Edit /> : <AddCircle />}
          </IconButton>
          {deletable && (
            <IconButton onClick={show} color="error" size="small">
              <Delete />
            </IconButton>
          )}
        </Box>
      </TableCell>
      <PriceDeleteDialog
        open={visible}
        handleClose={close}
        priceId={price.id}
      />
    </TableRow>
  );
};
